import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateShareClassDto } from '../../types/share-classes.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreate = () => {
  const { mutate: create, isPending } = useAppMutation([QueryKey.CREATE_SHARE_CLASS], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreateShareClassDto }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'share-classes'] },
        { body: data },
      ),
  });
  return { create, isPending };
};
